// extracted by mini-css-extract-plugin
export var text = "separator-with-text-module--text--5867b";
export var wrapper = "separator-with-text-module--wrapper--82e02";